import React, { useEffect } from 'react';
import { getPokusAssignVariantClientData } from '@growth/pokus/assign-variant';
import { useApiCall } from '@growth/custom-hooks/useApiCall';
import { isUserTokenPresent } from '@growth/auth-helpers';
import { getQueryParam } from '@growth/location';
import { getDeviceType } from '@growth/user-agents';
import { useHasMounted } from '@growth/custom-hooks/useHasMounted';
import { isRelatedAppInstalled } from '@growth/pwa-helper';
import { H as HOC_API_RESPONSE } from './constant-7cd90700.esm.js';
import { docSessionStorage } from '@growth/browser-storage';
import { setItem, getItem } from '@growth/cookies';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var APPEARANCE_SESSION = '__gr_m2a_ta';
var timeLimit = 45 * 60 * 1000; // 45 mins to milliseconds
var ctaBtnIds = {
  fullBtn: 'fullcta',
  halfBtn: 'halfcta'
};
var gocashTimerCookie = {
  CookieName: 'gr_ttn',
  MaxAge: 2 * 24 * 60 * 60,
  // 2 days in seconds
  Domain: '.goibibo.com'
};

var getAppearaceSession = function getAppearaceSession() {
  return docSessionStorage.getItem(APPEARANCE_SESSION);
};
var setTimerCookie = function setTimerCookie() {
  setItem(gocashTimerCookie.CookieName, String(new Date()), {
    expires: gocashTimerCookie.MaxAge,
    // 2 * 24 * 60 * 60
    path: '/',
    domain: gocashTimerCookie.Domain,
    secure: true
  });
};
var getTimerCookie = function getTimerCookie() {
  return getItem(gocashTimerCookie.CookieName);
};
var getEndingTime = function getEndingTime(startingTime) {
  return new Date(new Date(startingTime).getTime() + timeLimit);
};
var appendZero = function appendZero(num) {
  if (num <= 0) return "00";
  return num < 10 ? "0" + num : "" + num;
};
var getBtnDisplayedById = function getBtnDisplayedById(isOnClient) {
  var btnId = ctaBtnIds.halfBtn;
  if (isOnClient) {
    var _document$getElementB;
    var isFullbtnElemId = (_document$getElementB = document.getElementById(ctaBtnIds.fullBtn)) == null ? void 0 : _document$getElementB.id;
    btnId = isFullbtnElemId || ctaBtnIds.halfBtn;
  }
  return btnId;
};

var AB_KEY = 'growthMwebToAppExp';
var AB_CONFIG_KEY = 'growthMwebToAppExpConfig';
var AppBannerPokusHOC = function AppBannerPokusHOC(Component, componentType, isMobileComponent) {
  if (isMobileComponent === void 0) {
    isMobileComponent = true;
  }
  var AppBannerWithHOC = function AppBannerWithHOC(props) {
    var _linkDetails$extraDat;
    var page = props.page,
      lobName = props.lobName,
      linkDetails = props.linkDetails,
      text = props.text,
      extraInfo = props.extraInfo,
      onPokusComplete = props.onPokusComplete,
      ssr = props.ssr,
      lastSearchedLob = props.lastSearchedLob;
    var _useApiCall = useApiCall(getPokusAssignVariantClientData),
      pokusResp = _useApiCall[0],
      getPokusData = _useApiCall[1];
    var data = pokusResp.data,
      pokusError = pokusResp.error,
      pokusCompleted = pokusResp.completed,
      pokusLoading = pokusResp.loading;
    var pokusData = data || {};
    var trafficSource = linkDetails == null || (_linkDetails$extraDat = linkDetails.extraData) == null ? void 0 : _linkDetails$extraDat.trafficSource;
    var isLoggedIn = isUserTokenPresent();
    var hasMounted = useHasMounted();

    /**
     * Fetch app banner data from pokus before opening/rendring the app banners.
     * */
    useEffect(function () {
      isRelatedAppInstalled().then(function (isAppInstalled) {
        var _getQueryParam, _getQueryParam2, _getQueryParam3;
        /**  waiting for appInstall check method to get complete */
        var qs = {
          utm_source: ((_getQueryParam = getQueryParam('utm_source')) == null ? void 0 : _getQueryParam.toLowerCase()) || '',
          utm_medium: ((_getQueryParam2 = getQueryParam('utm_medium')) == null ? void 0 : _getQueryParam2.toLowerCase()) || '',
          utm_campaign: ((_getQueryParam3 = getQueryParam('utm_campaign')) == null ? void 0 : _getQueryParam3.toLowerCase()) || ''
        };
        getPokusData({
          pokusOptions: {
            isMobile: isMobileComponent,
            attributes: _extends({
              page: page,
              lob: lobName,
              IsLoggedIn: isLoggedIn,
              traffic_source: trafficSource,
              isAppInstalled: isAppInstalled,
              lastSearchedLob: lastSearchedLob || 'undefined',
              utm_source: qs.utm_source,
              utm_medium: qs.utm_medium,
              utm_campaign: qs.utm_campaign,
              bannerType: componentType,
              isTopNavTimerShown: !!getTimerCookie(),
              device: getDeviceType()
            }, extraInfo == null ? void 0 : extraInfo.pokusAttributes)
          }
        });
      });
    }, [isLoggedIn, lastSearchedLob]);
    var analyticsSendAll = function analyticsSendAll(obj) {
      //	pdt.sendPdtEvent(obj);
    };

    /** Send the error and success events of api calls */
    useEffect(function () {
      if (pokusCompleted && !pokusError) {
        analyticsSendAll({
          event: HOC_API_RESPONSE,
          action: 'pokus-ok',
          ab_experiment: AB_KEY + ":" + pokusData[AB_KEY]
        });
      }
    }, [pokusError, pokusCompleted]);

    /**
     * We take app banner details in "text" prop as well and merge it with pokus response
     * and pass it to banner component.
     */
    var setTextFromPokusOrProps = function setTextFromPokusOrProps(_ref) {
      var abConfigValue = _ref.abConfigValue;
      var _ref2 = abConfigValue || {},
        _ref2$pages = _ref2.pages,
        pages = _ref2$pages === void 0 ? {} : _ref2$pages;
      var apiLinkDetails;
      var apiText;

      /** get text and linkDetails from pages list, if present */
      if (pages[page]) {
        var _pages$page, _pages$page2;
        apiLinkDetails = ((_pages$page = pages[page]) == null ? void 0 : _pages$page.linkDetails) || {};
        apiText = ((_pages$page2 = pages[page]) == null ? void 0 : _pages$page2.text) || {};
      } else {
        apiLinkDetails = (abConfigValue == null ? void 0 : abConfigValue.linkDetails) || {};
        apiText = (abConfigValue == null ? void 0 : abConfigValue.text) || {};
      }
      var linkDetailsWithAPI = _extends({}, linkDetails, apiLinkDetails);
      linkDetailsWithAPI.extraData = _extends({}, linkDetailsWithAPI.extraData, {
        trafficSource: trafficSource
      }); // explicitly setting the traffic source again as pokus doesn't send the traffic-source in return
      var textWithAPI = _extends({}, text, apiText);
      return {
        linkDetailsWithAPI: linkDetailsWithAPI,
        textWithAPI: textWithAPI
      };
    };

    /**
     * If pokus is loading or not completed and ssr is true then app banner can render on server side as well
     * It's upto indivisual banner that what it renders on loading state. TopBanner renders a
     * shimmer on loading state to avoid CLS.
     */
    var shouldShowBanner = !!(pokusCompleted && pokusData[AB_KEY] && pokusData[AB_CONFIG_KEY]);
    var shouldShowLoading = !!(ssr && !hasMounted || !pokusCompleted || pokusLoading);
    if (shouldShowLoading) {
      return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
        hocProps: {
          loading: true
        }
      }));
    }

    // return the matched banner component
    if (shouldShowBanner) {
      var abKeyValue = pokusData[AB_KEY];
      var abConfigValue = pokusData[AB_CONFIG_KEY];
      if (abKeyValue === componentType) {
        if (onPokusComplete) onPokusComplete(true);
        var _setTextFromPokusOrPr = setTextFromPokusOrProps({
            abConfigValue: abConfigValue
          }),
          linkDetailsWithAPI = _setTextFromPokusOrPr.linkDetailsWithAPI,
          textWithAPI = _setTextFromPokusOrPr.textWithAPI;

        /** Include pokus experiment details and user details */
        var hocProps = {
          experimentKey: AB_KEY,
          experimentValue: abKeyValue,
          trafficSource: trafficSource
        };
        return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
          linkDetails: linkDetailsWithAPI,
          text: textWithAPI,
          hocProps: hocProps
        }));
      }
      if (onPokusComplete) onPokusComplete(false);
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null);
  };
  return AppBannerWithHOC;
};

export { AppBannerPokusHOC as A, _extends as _, appendZero as a, getEndingTime as b, ctaBtnIds as c, getAppearaceSession as d, getBtnDisplayedById as e, getTimerCookie as g, setTimerCookie as s };
